export const handleNcdAttributeValue = (value: string) => {
  if (value === 'S') {
    return 'Second car'
  } else if (value === 'N') {
    return 'Spouse’s car'
  } else if (value === 'C') {
    return 'Company car'
  } else if (value === 'M') {
    return 'Motability Scheme'
  } else if (value === 'CC') {
    return 'Car club'
  } else {
    return 'None apply'
  }
}
